import { ref } from 'vue'
import firebase from '../../firebase'
import { doc, getDoc } from 'firebase/firestore'

const getWallet = () => {
  const walletInfo = ref(null)
  const getWalletByUid = async (uid) => {
    const docRef = doc(firebase.db, 'web3Wallets', uid)
    const docSnap = await getDoc(docRef)

    if (docSnap.exists()) {
      walletInfo.value = docSnap.data()
    }
  }
  return { getWalletByUid, walletInfo }
}
export default getWallet
